<template>
    <div class="right head-right">
        <div id="no-barrier">
            <a href="javascript:void(0)" id="wza" clickHide="false">无障碍</a>
            <span class="divider"></span>
            <a href="javascript:void(0)" id="ghb" clickHide="false">关怀版</a>
        </div>
        <div id="head-login"><login-btn></login-btn></div>
    </div>
</template>
<script>
import LoginBtn from './LoginBtn.vue'
export default {
    components: {
        LoginBtn
    },
    data() {
        return {
            
        }
    },
    mounted() {
    },
    methods: {
        
    }
}
</script>
<style lang="less">
.head-right{
        display: inline-flex;
        align-items: center;
        height: 100%;
    }

    #no-barrier{
        display: inline-block;
        height: 28px;
        width: 109px;
        border: 1px solid rgba(255,255,255,0.4);
        margin-right: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        a {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
            &:first-child {
                margin-right: 4px;
            }
            &:last-child {
                margin-left: 4px;
            }
            &:hover{
                cursor: pointer;
                color: #fff;
                font-weight: 600;
            }
        }
        .divider {
            display: block;
            width: 1px;
            height: 12px;
            background-color: #666;
        }
    }
    #head-login{
        display: inline-block;
    }
</style>